import React from "react";
import { Sparkles, Handshake, Presentation, LineChart, BookOpen, Target } from "lucide-react";
import { capabilities } from "../mock";

const iconMap = { Sparkles, Handshake, Presentation, LineChart, BookOpen, Target };

export default function Capabilities() {
  return (
    <section className="py-24 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="text-xs tracking-[0.32em] text-emerald-400 uppercase mb-4">02 — Capabilities</div>
            <h2 className="gt-serif text-4xl md:text-5xl max-w-2xl">Built for revenue, not for resumes.</h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {capabilities.map((c) => {
            const Icon = iconMap[c.icon] || Sparkles;
            return (
              <div
                key={c.title}
                className="group gt-hairline gt-hover-lift rounded-2xl p-6 bg-white/[0.02]"
              >
                <div className="w-11 h-11 rounded-xl bg-emerald-400/10 border border-emerald-400/30 flex items-center justify-center mb-5 group-hover:bg-emerald-400/20 transition-colors">
                  <Icon className="w-5 h-5 text-emerald-400" />
                </div>
                <h3 className="text-white text-lg font-medium">{c.title}</h3>
                <p className="mt-2 text-sm text-neutral-400 leading-relaxed">{c.copy}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
